module.exports = __webpack_public_path__ + "img/Group37.5328588b.png";